<div class="service__info--box" >
    <span>{{ contactNo}}</span>
    <div>
        <a href="tel:{{contactNo}}{{openUrl}}">
            <img class="service-image mr-2" src="assets/img/phonebutton.png" alt="" loading="lazy">
        </a>         
        <a [href]="'viber://chat?number='+viberNo+''+openUrl | safeUrl" *ngIf="isIOS==false && isShowViber">
            <img class="service-image" src="assets/img/viberbutton.png" alt="" loading="lazy">
        </a>
        <a [href]="'viber://chat?number='+contactNo+''+openUrl | safeUrl" *ngIf="isIOS==true && isShowViber">
            <img class="service-image" src="assets/img/viberbutton.png" alt="" loading="lazy">
        </a>
    </div>
</div>
